import { type Dispatch, useCallback, useState } from "react";
import { useNavigate } from "react-router";
import { useTypedLocation } from "src/utils/hooks/useTypedLocation";
import { navigateToNewState } from "src/utils/location/navigateToNewState";
import type { Action } from "../TripPlannerProvider";
import { useTripURLGeocodedPlaces } from "./useTripURL";

export function useInitialTripFromURL(dispatch: Dispatch<Action>) {
  const [hasUsedSearch, setHasUsedSearch] = useState(false);
  const { places, tripIdData, isFromSearchParam } = useTripURLGeocodedPlaces();
  const navigate = useNavigate();
  const location = useTypedLocation();

  const addTripFromURL = useCallback(() => {
    if (places.length && !hasUsedSearch) {
      let tripDataWithDefaults = {
        transport: {},
      };
      if (tripIdData) {
        tripDataWithDefaults = tripIdData;
      }
      dispatch({
        type: "PASSIVE_UPDATE",
        trip: {
          ...tripDataWithDefaults,
          places,
        },
      });
      setHasUsedSearch(true);
      // Replaces browser history with new tripPlannerDetails on first load
      navigateToNewState(
        navigate,
        {
          ...location.state,
          tripPlannerDetails: {
            ...tripDataWithDefaults,
            places,
          },
        },
        location,
        true,
      );
    }
  }, [places, hasUsedSearch, tripIdData, dispatch, navigate, location]);

  return {
    addTripFromURL,
    hasUsedSearch,
    isFromSearchParam,
  };
}
